// Share Link
class Notification {
    init () {
        $(document).on('click', '.js-shareCta', function () {
            const $this = $(this);
            navigator.clipboard.writeText(window.location.href);

            $(this).addClass('cc-active');
            setTimeout(function() {
                $this.removeClass('cc-active');
            }, 4000);
        });
    }
}

const notification = new Notification();
export default notification;
